import {Component, Inject, forwardRef} from '@angular/core';
import {AppComponent} from './app.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {
    user: string;
	searchQuery:string;
    constructor(public app: AppComponent,
	    private router: Router,) {}

    openFolder(){
		var folder = `{"label":"Entrepreneur Zone","data":"43","expandedIcon":"fa-folder-open","collapsedIcon":"fa-folder","leaf":true,"parent":1,"count":4,"color":"#1a1718","icon":null,"description":null,"logo":null}`;
		this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
			this.router.navigate(['content', folder]);
		});
	}

    search() {

	    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
		    this.router.navigate(['content'], {queryParams : {search : this.searchQuery} });
	    });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.topbar.component.ts